module.exports = __webpack_public_path__ + "img/gatschkopf.09e1fffd.jpg";